// src/index.ts
import { CharacterCount } from "@tiptap/extensions";
import { CharacterCount as CharacterCount2 } from "@tiptap/extensions";
var index_default = CharacterCount;
export {
  CharacterCount2 as CharacterCount,
  index_default as default
};
//# sourceMappingURL=index.js.map